<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Session Info</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Session Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.name"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Session Slug</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ form.slug }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor
                  v-if="showDesc"
                  v-model="form.shortdesc"
                  :config="{
                    plugins: ['blockcode'],
                    addbarAdd: ['text', 'card'],
                    css: '/article-editor/css/',
                    format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                    align: {
                      left: 'text-left',
                      center: 'text-center',
                      right: 'text-right',
                      justify: 'text-justify'
                    }
                  }"
                ></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.shortdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Long Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor
                  v-if="showDesc"
                  v-model="form.longdesc"
                  :config="{
                    plugins: ['blockcode'],
                    addbarAdd: ['text', 'card'],
                    css: '/article-editor/css/',
                    format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                    align: {
                      left: 'text-left',
                      center: 'text-center',
                      right: 'text-right',
                      justify: 'text-justify'
                    }
                  }"
                ></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.longdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Session Date</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <flat-pickr
                  :config="configFromdateTimePicker"
                  v-model="form.daterange[0]"
                  placeholder="From Date Time"
                />
                <span class="px-2">to</span>
                <flat-pickr
                  :config="configTodateTimePicker"
                  v-model="form.daterange[1]"
                  placeholder="To Date Time"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Venue/Stage</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!--
                <vs-select v-model="form.venue">
                  <vs-select-item :value="`Stream 1`" :text="`Stream 1`" />
                  <vs-select-item :value="`Stream 2`" :text="`Stream 2`" />
                  <vs-select-item :value="`Stream 2`" :text="`Stream 2`" />
                  <vs-select-item :value="`Stream 3`" :text="`Stream 3`" />
                  <vs-select-item :value="`Main Stage`" :text="`Main Stage`" />
                </vs-select>
                -->
                <vs-input
                  v-validate=""
                  name="venue"
                  class="w-full"
                  v-model="form.venue"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Quantity</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="number"
                  class="w-full"
                  :min="0"
                  v-model="form.qty"
                  @input="quantityValidation"
                />

                <span
                  class="text-danger text-sm"
                  v-show="!quantityValid"
                  > Quantity can only be 1 or more or leave blank for unlimited</span
                >
                <span
                  class="text-grey text-sm"
                  v-show="quantityValid && (form.qty === '' || form.qty === null)"
                  > Quantity will be unlimited</span
                >
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Mode</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="mode"
                      v-model="form.mode"
                      :vs-value="`online`"
                      >Online</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="mode"
                      v-model="form.mode"
                      :vs-value="`session`"
                      >Session</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Listing Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Show in Session Booking</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="workshop_listing_status"
                      v-model="form.workshop_listing_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="workshop_listing_status"
                      v-model="form.workshop_listing_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Speaker URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="speaker_url"
                  class="w-full"
                  v-model="form.speaker_url"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Join URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="form.join_url" />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Event Filter</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select v-model="event_filter">
                  <vs-select-item
                    v-for="(item, index) in filterList"
                    :key="index"
                    :value="item.filter_slug"
                    :text="item.filter_name"
                  />
                </vs-select>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Poster Image</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <img :src="form.poster" style="width: 120px" class="mb-2" />
                <vs-input
                  type="file"
                  ref="poster"
                  name="poster"
                  class="w-full"
                  @change="setPoster"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('poster')"
                  >{{ errors.first("poster") }}</span
                >
              </div>
            </div>
          </section>
          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Update Session</vs-button
              >
            </div>
          </div>
        </vs-card>

        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Speaker</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Select Speakers in this session</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <v-select
                  multiple
                  label="name"
                  v-model="selectedSpeaker"
                  :closeOnSelect="false"
                  :options="speakerList"
                />
              </div>
            </div>
          </section>
          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="liveEventSubmit"
                >Update Speaker</vs-button
              >
            </div>
          </div>
        </vs-card>

        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Core Video</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Streaming Source 1</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.live_engine" vs-value="zoom"
                      >Zoom</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.live_engine" vs-value="ivs"
                      >AWS IVS</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine"
                      vs-value="vimeo"
                      >Vimeo</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine"
                      vs-value="facebook"
                      >Facebook</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine"
                      vs-value="youtube"
                      >Youtube</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine"
                      vs-value="dacast"
                      >Dacast</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Streaming Source 2</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.live_engine_2" vs-value="zoom"
                      >Zoom</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.live_engine_2" vs-value="ivs"
                      >AWS IVS</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine_2"
                      vs-value="vimeo"
                      >Vimeo</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine_2"
                      vs-value="facebook"
                      >Facebook</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine_2"
                      vs-value="youtube"
                      >Youtube</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      :disabled="false"
                      v-model="form.live_engine_2"
                      vs-value="dacast"
                      >Dacast</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Vimeo Playback URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="name"
                  class="w-full"
                  v-model="form.vimeo_playback_url"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Dacast Playback URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="name"
                  class="w-full"
                  v-model="form.dacast_playback_url"
                />
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="form.ivs_viewer_endpoint_url == null"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-button @click="createIVS()" size="small"
                  >Create IVS Channel</vs-button
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>IVS Streaming URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.ivs_viewer_endpoint_url == null"
                  name="name"
                  class="w-full"
                  v-model="form.ivs_creator_endpoint_url"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>IVS Streaming Key</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.ivs_viewer_endpoint_url == null"
                  name="name"
                  class="w-full"
                  v-model="form.ivs_creator_stream_key"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>IVS Player URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.ivs_viewer_endpoint_url == null"
                  name="name"
                  class="w-full"
                  v-model="form.ivs_viewer_endpoint_url"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>IVS Channel ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.ivs_viewer_endpoint_url == null"
                  name="name"
                  class="w-full"
                  v-model="form.ivs_channel_id"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>IVS Playback URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.ivs_viewer_endpoint_url == null"
                  name="name"
                  class="w-full"
                  v-model="form.ivs_playback_url"
                />
              </div>
            </div>
            <hr />
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Rerun Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="rerun_status"
                      v-model="form.rerun_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="rerun_status"
                      v-model="form.rerun_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="eventSubmit"
                >Update</vs-button
              >
            </div>
          </div>
        </vs-card>

        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Live Video</h1>
            <template v-if="video == null || video.live_engine == ''">
              <div class="text-center m-5">
                <vs-alert active="true" color="danger">
                  Oops! Video has not beed setup yet.
                </vs-alert>
              </div>

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Streaming Source</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio v-model="videoForm.live_engine" vs-value="ivs"
                        >AWS IVS</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        :disabled="false"
                        v-model="videoForm.live_engine"
                        vs-value="vimeo"
                        >Vimeo</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        :disabled="true"
                        v-model="videoForm.live_engine"
                        vs-value="facebook"
                        >Facebook</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        :disabled="true"
                        v-model="videoForm.live_engine"
                        vs-value="youtube"
                        >Youtube</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div class="vx-row pt-5">
                <div class="vx-col sm:w-2/3 w-full ml-auto">
                  <vs-button class="mr-3 mb-2" @click.prevent="liveVideoSubmit"
                    >Create Video</vs-button
                  >
                </div>
              </div>
            </template>

            <template v-else>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Streaming Engine</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ video.live_engine }}
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Streaming URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    name="name"
                    class="w-full"
                    v-model="video.stream_url"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Streaming Key</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    name="name"
                    class="w-full"
                    v-model="video.stream_key"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Player URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    name="name"
                    class="w-full"
                    v-model="video.player_url"
                  />
                </div>
              </div>
            </template>
          </section>
          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="liveVideoUpdate"
                >Update Video</vs-button
              >
            </div>
          </div>
        </vs-card>

        <vs-card class="px-5 py-5" v-if="liveEvent != null">
          <section>
            <h1 class="pb-5">Group Chat</h1>
            <template v-if="liveEvent != null">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Chat Group ID</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ liveEvent.applozic_group_id }}
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Chat Client Group ID</span>
                </div>
                <div v-if="liveEvent.applozic_group_data" class="vx-col sm:w-2/3 w-full">
                  {{ liveEvent.applozic_group_data.clientGroupId }}
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Group Name</span>
                </div>
                <div  v-if="liveEvent.applozic_group_data" class="vx-col sm:w-2/3 w-full">
                  {{ liveEvent.applozic_group_data.name }}
                </div>
              </div>
            </template>
          </section></vs-card
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import vSelect from "vue-select";
import ArticleEditor from "@/components/ArticleEditor.vue";

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: { flatPickr, vSelect, ArticleEditor },
  props: ["slug"],
  data: () => ({
    showDesc: true,
    valid: true,
    editorOption: {
      modules: {
        toolbar: "#toolbar"
      }
    },
    editor2Option: {
      modules: {
        toolbar: "#toolbar-2"
      }
    },
    event_filter: "",
    form: {
      s: null,
      name: "",
      slug: "",
      daterange: [moment().unix(), moment().unix()],
      selldaterange: [
        moment().format("YYYY-MM-DD HH:mm:ss"),
        moment().format("YYYY-MM-DD HH:mm:ss")
      ],
      shortdesc: "",
      longdesc: "",
      timezone: "Asia/Bangkok",
      venue: "",
      poster: null,
      zoom_status: 0,
      zoom_account_no: null,
      session_type: "webinar",
      mode: "online",
      freeevent: 1,
      privacy: "private",
      private_token: "",
      speaker_url: "",
      qty: 0,
    },
    file: {
      poster: null
    },
    datetime: null,
    configFromdateTimePicker: {
      minDate: null,
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    configTodateTimePicker: {
      minDate: null,
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    liveEvent: null,
    speakerList: [],
    selectedSpeaker: [],
    videoForm: {
      object_id: null,
      live_engine: "ivs"
    },
    video: null,
    session_id: null,
    filterList: [],
    quantityValid: true,
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  created() {
    this.$vs.loading();
    setTimeout(() => {
      if (this.e) {
        this.loadSpeaker();
        this.loadFilter();
      }

      /* CORE EVENT */
      Service.Event.get(this.slug)
        .then(res => {
          this.$vs.loading.close();

          this.session_id = res.data.event.event_id;

          let rerun_status = 0;
          if (res.data.event.rerun_status) {
            rerun_status = 1;
          }

          let publish_status = 0;
          if (res.data.event.publish_status == 1) {
            publish_status = 1;
          }

          let listing_status = 0;
          if (res.data.event.listing_status == 1) {
            listing_status = 1;
          }

          let workshop_listing_status = 0;
          if (res.data.event.workshop_listing_status == 1) {
            workshop_listing_status = 1;
          }

          this.form = {
            ...res.data.event,
            s: res.data.event.merchant.s,
            name: res.data.event.pro_name,
            slug: res.data.event.slug,
            daterange: [
              moment(res.data.event.datetime, "YYYY-MM-DD HH:mm:ss").unix() *
                1000,
              moment(
                res.data.event.datetime_end,
                "YYYY-MM-DD HH:mm:ss"
              ).unix() * 1000
            ],
            selldaterange: [
              moment().format("YYYY-MM-DD HH:mm"),
              moment().format("YYYY-MM-DD HH:mm")
            ],
            shortdesc: res.data.event.pro_shortdesc+"",
            longdesc: res.data.event.pro_longdesc+"",
            timezone: res.data.event.timezone,
            venue: res.data.event.venue,
            qty:
              res.data.event.products[res.data.event.products.length - 1].qty,
            poster: res.data.event.poster,
            speaker_url: res.data.event.speaker_url,
            private_token: "",
            rerun_status: rerun_status,
            publish_status: publish_status,
            listing_status: listing_status,
            workshop_listing_status: workshop_listing_status
          };

          this.showDesc =false;
          setTimeout(()=>{
            this.showDesc = true;
          },300)

          this.videoForm.object_id = res.data.event.event_id;

          let data = {
            e: this.e
          };

          let params = Object.keys(data)
            .map(key => key + "=" + data[key])
            .join("&");

          Service.Event.getVideo(res.data.event.event_id, params).then(
            video => {
              if (video.data.video != null) {
                this.video = video.data.video;
              }
            }
          );
          this.loadLiveEvent(res.data.event.event_id);
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    }, 800);
  },
  watch: {
    "form.name": function(newVal, oldVal) {
      /*
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false, // strip special characters except replacement, defaults to `false`
      });
      */
    }
  },
  methods: {
    quantityValidation() {
      if(this.form.qty === 0) {
        this.quantityValid = false;
      } else {
        this.quantityValid = this.form.qty === '' || this.form.qty === null || (!isNaN(this.form.qty) && this.form.qty > 0);
      }
    },
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "event",
        currentPage: 1,
        perPage: 50
      };

      let params = Object.keys(filterData)
        .map(key => key + "=" + filterData[key])
        .join("&");

      Service.Filter.gets(params).then(res => {
        this.filterList = res.data.rows;
      });
    },
    loadLiveEvent(id) {
      Service.LiveEvent.get(id, this.e)
        .then(res => {
          this.liveEvent = res.data.session;
          this.event_filter = res.data.session.event_filter;
          this.selectedSpeaker = this.liveEvent.speakers.map(item => {
            return {
              name: item.speaker_firstname + " " + item.speaker_lastname,
              value: item.speaker_id
            };
          });
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    },
    loadSpeaker() {
      let data = {
        e: this.e,
        currentPage: 1,
        perPage: 1000
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Speaker.gets(params).then(res => {
        this.speakerList = res.data.rows.map(item => {
          return {
            value: item.speaker_id,
            name: item.speaker_firstname + " " + item.speaker_lastname
          };
        });
      });
    },
    validateForm() {
      this.quantityValidation()
      this.$validator.validateAll().then(result => {
        if (result && this.quantityValid) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    validateSlug() {
      this.$vs.loading();
      Service.Event.search(this.form.slug).then(res => {
        if (res.data.results.length > 0) {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : This slug already used by others.",
            color: "danger",
            fixed: true
          });
        }
        this.$vs.loading.close();
      });
    },
    createIVS() {
      let data = {
        e: this.liveEvent.slug,
        ivs_start: true
      };
      this.$vs.loading();
      Service.Event.update(data).then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });

        let rerun_status = 0;
        if (res.data.event.rerun_status) {
          rerun_status = 1;
        }

        this.form = {
          ...res.data.event,
          s: res.data.event.merchant.s,
          name: res.data.event.pro_name,
          slug: res.data.event.slug,
          daterange: [
            moment(res.data.event.datetime, "YYYY-MM-DD HH:mm:ss").unix() *
              1000,
            moment(res.data.event.datetime_end, "YYYY-MM-DD HH:mm:ss").unix() *
              1000
          ],
          selldaterange: [
            moment().format("YYYY-MM-DD HH:mm"),
            moment().format("YYYY-MM-DD HH:mm")
          ],
          shortdesc: res.data.event.pro_shortdesc+"",
          longdesc: res.data.event.pro_longdesc+"",
          timezone: res.data.event.timezone,
          venue: res.data.event.venue,
          qty: res.data.event.products[res.data.event.products.length - 1].qty,
          poster: res.data.event.poster,
          speaker_url: res.data.event.speaker_url,
          private_token: "",
          rerun_status: rerun_status
        };
        this.showDesc =false;
          setTimeout(()=>{
            this.showDesc = true;

          },300)
        this.$vs.loading.close();
      });
    },
    submit() {
      let data = {
        e: this.e,
        s: this.s
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      /*CONVERT DATE FORMAT */
      this.form.datetime = moment(this.form.daterange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.form.datetime_end = moment(this.form.daterange[1]).format(
        "YYYY-MM-DD HH:mm"
      );

      if (this.form.datetime == "Invalid date") {
        this.form.datetime = moment(
          this.form.daterange[0],
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }

      if (this.form.datetime_end == "Invalid date") {
        this.form.datetime_end = moment(
          this.form.daterange[1],
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }

      this.form.e = this.slug;
      this.form.parent_id = this.parent_id;
      this.form.sync = true;

      const qty = this.form.qty;

      this.$vs.loading();

      Service.Product.updateQty(
        {
          qty: qty
        },
        this.form.products[this.form.products.length - 1].product_id
      ).then(() => {

        Service.Event.update(this.form)
          .then(res => {
            this.form.qty = qty;
            if (res.success) {
              let data = {
                event_id: this.liveEvent.event_id,
                event_filter: this.event_filter,
                e: this.e
              };

              Service.LiveEvent.update(data).then(res => {
                this.$vs.loading.close();
                this.doUploadFile();
              });
            }
            this.$vs.loading.close();
          })
          .catch(err => {
            this.$vs.notify({
              title: "Oops!",
              text: "ERROR : " + err.error,
              color: "danger"
            });
            this.$vs.loading.close();
          });
      });
    },
    eventSubmit() {
      let data = {
        e: this.liveEvent.slug,
        live_engine: this.form.live_engine,
        live_engine_2: this.form.live_engine_2,
        vimeo_playback_url: this.form.vimeo_playback_url,
        dacast_playback_url: this.form.dacast_playback_url,
        ivs_creator_endpoint_url: this.form.ivs_creator_endpoint_url,
        ivs_creator_stream_key: this.form.ivs_creator_stream_key,
        ivs_viewer_endpoint_url: this.form.ivs_viewer_endpoint_url,
        ivs_channel_id: this.form.ivs_channel_id,
        ivs_playback_url: this.form.ivs_playback_url,
        rerun_status: 0,
        publish_status: 0,
        listing_status: 0,
        mode: this.form.mode
      };

      if (this.form.rerun_status == 1) {
        data.rerun_status = 1;
      }

      if (this.form.publish_status == 1) {
        data.publish_status = 1;
      }

      if (this.form.listing_status == 1) {
        data.listing_status = 1;
      }

      this.$vs.loading();
      Service.Event.update(data).then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
        this.$vs.loading.close();
      });
    },
    liveEventSubmit() {
      let data = {
        event_id: this.liveEvent.event_id,
        speaker_ids: [],
        event_filter: this.event_filter,
        e: this.e
      };
      this.selectedSpeaker.map(item => {
        data.speaker_ids.push(item.value);
      });
      this.$vs.loading();
      Service.LiveEvent.update(data).then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
        this.$vs.loading.close();
      });
    },
    liveVideoSubmit() {
      let data = { e: this.e };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      Service.Event.createVideo(params, this.videoForm).then(res => {
        let data = {
          e: this.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        Service.Event.getVideo(this.liveEvent.event_id, params).then(video => {
          if (video.data.video != null) {
            this.video = video.data.video;
          }
          this.$vs.loading.close();
        });
      });
    },
    liveVideoUpdate() {
      let data = { e: this.e };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      Service.Event.updateVideo(params, this.video)
        .then(res => {
          console.log(res);
          this.$vs.loading.close();
        })
        .catch(e => {
          this.$vs.loading.close();
        });
    },
    setPoster(e) {
      this.file.poster = e.target.files[0];
    },
    doUploadFile() {
      if (this.file.poster != null) {
        this.$vs.loading();
        var formData = new FormData();
        formData.append("type", "poster");
        formData.append("file", this.file.poster);

        Service.Event.upload(this.slug, formData).then(res => {
          if (res.success) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
            //location.reload();
          }
        });
      } else {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
      }
    },
    onEditorBlur(quill) {
      //console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      //console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      //console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      //console.log("editor change!", quill, html, text);
      //this.content = html;
    },
    onFromChange(selectedDates, dateStr, instance) {
      //et min = moment(dateStr, "DD-MM-YYYY HH:mm").unix() * 1000;
      //this.$set(this.configTodateTimePicker, "minDate", min);
    },
    onToChange(selectedDates, dateStr, instance) {
      //let max = moment(dateStr, "DD-MM-YYYY HH:mm").unix() * 1000;
      //this.$set(this.configFromdateTimePicker, "maxDate", max);
    }
  }
};
</script>
<style>
.editor {
  height: 10rem;
  margin-bottom: 0px;
}
</style>
